import { ContentSocialIcon } from '../models/social-icons.interfaces';

export const mockSocialIcons: ContentSocialIcon[] = [
  {
    iconAlt: 'Facebook',
    iconLink: 'https://www.facebook.com/delta',
    iconLogo:
      '//st.delta.com/content/www/us/en.damAssetRender.20211110T1419425980500.html/content/dam/delta_homepage_redesign/hpr_optimized_images/social_icons/Facebook-icon-contrast.svg',
    openExternalLinkModal: 'false',
    avoidFocus: false,
    containerClass: ''
  },
  {
    iconAlt: 'Twitter',
    iconLink: 'https://www.twitter.com/delta',
    iconLogo:
      '//st.delta.com/content/www/us/en.damAssetRender.20211110T1419425450500.html/content/dam/delta_homepage_redesign/hpr_optimized_images/social_icons/Twitter-icon-contrast.svg',
    openExternalLinkModal: 'false',
    avoidFocus: false,
    containerClass: ''
  }
];
export const twitter: string = 'x';
export const twitterX: string = 'twitter(x)';
